import React, { useState, useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import PhoneInput from 'react-phone-input-2';

import {
  Grid,
  Typography,
  CircularProgress,
  ClickAwayListener,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core';

import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import CustomSelect from '../../CustomSelect/CustomSelect';
import TextFieldComp from '../../TextFieldComp';
import Tags from '../../AddTagsComp/index';
import './style.scss';
import { searchCustomer } from '../../../actions/customer/customer-actions';
import MultipleEmailFields from '../../MultipleEmailFields/MultipleEmailFields';

const useStyles = makeStyles((theme) => ({
  padding__left: {
    paddingLeft: '0.8rem',
    paddingBottom: '1.5rem',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '0',
    },
  },
  padding__right: {
    paddingRight: '0.8rem',
    paddingBottom: '1.5rem',
    [theme.breakpoints.down('sm')]: {
      paddingRight: '0',
    },
  },
  label: {
    color: '#545B7D',
    fontSize: '13px',
    fontWeight: 'normal',
    lineHeight: '16px',
    paddingBottom: '.65rem',
  },
  main__phone__input: {
    borderBottom: '0.25px solid #545b7d',
    marginTop: '9px !important',
    '& .form-control': {
      border: 'none',
      paddingLeft: '33px',
      height: '29px',
      color: '#545B7D',
      fontSize: '14px',
      fontWeight: '600',
      lineHeight: '18px',
      width: '100%',
      background: 'transparent',
    },
    '& .arrow': {
      display: 'none',
    },
    '& .selected-flag': {
      '&:hover': {
        background: 'transparent',
      },
      '&:focus': {
        background: 'transparent',
      },
    },
  },
  padding__btm__0: {
    paddingBottom: '0',
  },
  padding__btm: {
    paddingBottom: '1.5rem',
  },
  is__error: {
    color: '#E53935',
  },
  is__error__underline: {
    borderBottom: '0.25px solid #e53935',
  },
  adjust__align: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
  },
  customer__search__main: {
    maxHeight: '19rem',
    minHeight: '3rem',
    overflow: 'auto',
    width: '47%',
    position: 'absolute',
    zIndex: '999',
    top: '3.1rem',
    right: '53%',
    boxShadow: '0px 5px 16px rgba(0, 0, 0, 0.08)',
    padding: '0 1rem',
    borderRadius: '15px',
    background: '#fff',
  },
  customer__search__menu__text__heading: {
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '16px',
    color: '#000',
    padding: '.3rem 0',
  },
  customer__search__menu__text: {
    fontWeight: '500',
    fontSize: '13px',
    lineHeight: '16px',
    color: '#6D7D8B',
    padding: '.4rem 0 .3rem',
  },
  customer__search__list__item: {
    borderBottom: '0.25px solid #D4DCE8',
    padding: '0.5rem 0',
    cursor: 'poiter',
    '&:last-child': {
      borderBottom: '0',
    },
  },
}));
const selectStyle = {
  color: '#545B7D',
  fontSize: '14px',
  fontWeight: '600',
  lineHeight: '18px',
  background: 'transparent',
  borderTop: '0',
  borderLeft: '0',
  borderRight: '0',
  borderBottom: '0.25px solid #545b7d',
  borderRadius: '0',
  padding: '.7rem 0 0 0',
  letterSpacing: '-0.05px',
};

export default function CustomerFields({
  fields,
  handleChangeFields,
  laborClassOptions,
  laborClassLabel,
  setLaborClassLabel,
  errors,
  isViewOnly,
  handleSelectCutomerFromSearch,
  isAdditionalInfo = false,
}) {
  const dispatch = useDispatch();

  const [searchValue, setSearchValue] = useState('');
  const [showCustomers, setShowCustomers] = useState(false);

  const searchedCustomers = useSelector(
    (state) => state.customer?.searchedCustomers || [],
  );

  const searchCustomerLoading = useSelector(
    (state) => state.customer?.searchCustomerLoading || false,
  );

  const {
    name = '',
    email = '',
    phone = '',
    address = '',
    company = '',
    referalSource = '',
    tags = [],
    notes = '',
    usDotNumber = null,
    pstNumber = null,
    // if customer already attached then dont show customer search bar
    isCustomer = null,
    isTaxExempt = false,
    additionalEmails,
  } = fields;
  const classes = useStyles();

  // search customers

  const handleChangeSearch = _.debounce(async (value) => {
    if (!showCustomers) {
      setShowCustomers(true);
    }
    if (value) {
      dispatch(searchCustomer({ searchValue: value }));
    } else {
      setShowCustomers(false);

      dispatch({ type: 'CLEAR_SEARCH_CUSTOMER_STATE' });
    }
  }, 500);

  const handleSearchCustomers = useCallback((value) => {
    setSearchValue(value);
    handleChangeSearch(value);
  }, []);

  const handleSelectCustomer = (customer) => {
    handleSelectCutomerFromSearch(customer);
    setShowCustomers(false);
    setSearchValue('');
    dispatch({ type: 'CLEAR_SEARCH_CUSTOMER_STATE' });
  };
  return (
    <>
      <Grid container>
        <Grid
          item
          xs={12}
          md={12}
          className={clsx(classes.adjust__align, classes.padding__right)}
        >
          {!isCustomer && !isAdditionalInfo ? (
            <div className='p-relative'>
              <TextFieldComp
                placeholder='Search Customer via Name, Phone or Email, USDOT Number'
                onChange={(e) => handleSearchCustomers(e.target.value)}
                value={searchValue}
                onFocus={() => {
                  if (searchValue && !showCustomers) {
                    setShowCustomers(true);
                  }
                }}
              />

              {/* customer search */}
              {showCustomers ? (
                searchCustomerLoading ? (
                  <div
                    className={classes.customer__search__main}
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <CircularProgress size={20} />
                  </div>
                ) : (
                  <ClickAwayListener
                    onClickAway={() => setShowCustomers(false)}
                  >
                    {searchedCustomers?.length ? (
                      <div className={classes.customer__search__main}>
                        {searchedCustomers?.map((customer, key) => {
                          return (
                            <div
                              className={clsx(
                                'd-flex flex-col',
                                'c-pointer',
                                classes.customer__search__list__item,
                              )}
                              onClick={() => handleSelectCustomer(customer)}
                            >
                              <Typography
                                className={clsx(
                                  classes.customer__search__menu__text__heading,
                                )}
                                key={key++}
                              >
                                {customer?.name || '-'}
                              </Typography>
                              <div className='d-flex flex-col space-between'>
                                <Typography
                                  className={clsx(
                                    classes.customer__search__menu__text,
                                  )}
                                  key={key++}
                                >
                                  Phone :{' '}
                                  <span style={{ fontWeight: 400 }}>
                                    {customer.phone || '-'}
                                  </span>
                                </Typography>
                                <Typography
                                  className={clsx(
                                    classes.customer__search__menu__text,
                                  )}
                                  key={key++}
                                >
                                  Email:{' '}
                                  <span style={{ fontWeight: 400 }}>
                                    {customer?.email || '-'}
                                  </span>
                                </Typography>
                                <Typography
                                  className={clsx(
                                    classes.customer__search__menu__text,
                                  )}
                                  key={key++}
                                >
                                  USDOT Number:{' '}
                                  <span style={{ fontWeight: 400 }}>
                                    {customer?.usDotNumber || '-'}
                                  </span>
                                </Typography>
                                <Typography
                                  className={clsx(
                                    classes.customer__search__menu__text,
                                  )}
                                  key={key++}
                                >
                                  PST Number:{' '}
                                  <span style={{ fontWeight: 400 }}>
                                    {customer?.pstNumber || '-'}
                                  </span>
                                </Typography>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <div
                        className={classes.customer__search__main}
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      >
                        <Typography
                          className={clsx(classes.customer__search__menu__text)}
                          style={{
                            color: '#000000',
                            fontWeight: 400,
                            fontSize: '12px',
                            lineHeight: '19px',
                          }}
                        >
                          Result Not Found!
                        </Typography>
                      </div>
                    )}
                  </ClickAwayListener>
                )
              ) : (
                ''
              )}
            </div>
          ) : (
            ''
          )}
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          className={clsx(classes.adjust__align, classes.padding__right)}
        >
          <TextFieldComp
            name='name'
            value={name || ''}
            label='Customer Name *'
            placeholder='Enter Name*'
            onChange={handleChangeFields}
            error={errors?.name}
            disable={isViewOnly}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          className={clsx(classes.adjust__align, classes.padding__left)}
        >
          <TextFieldComp
            name='email'
            type='email'
            value={email || ''}
            label='Customer Email'
            placeholder='Enter Email Address'
            onChange={handleChangeFields}
            error={errors?.email}
            disable={isViewOnly}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          className={clsx(
            classes.adjust__align,
            classes.padding__right,
            'phone__field',
          )}
        >
          <Typography
            className={clsx(classes.label, errors?.phone && classes.is__error)}
          >
            Phone Number *
          </Typography>
          <PhoneInput
            country='us'
            id='phone'
            placeholder='Phone Number*'
            name='phone'
            value={phone || ''}
            error={errors?.phone}
            containerClass={clsx(
              classes.main__phone__input,
              errors?.phone && classes.is__error__underline,
            )}
            InputProps={{ disableUnderline: true }}
            onChange={(value, country, e, formattedValue) => {
              handleChangeFields({
                target: {
                  name: 'phone',
                  value: formattedValue,
                },
              });
            }}
            disabled={isViewOnly}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          className={clsx(classes.adjust__align, classes.padding__left)}
        >
          <TextFieldComp
            name='address'
            value={address || ''}
            label='Address'
            placeholder='Enter Address'
            onChange={handleChangeFields}
            disable={isViewOnly}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          className={clsx(classes.adjust__align, classes.padding__right)}
        >
          <TextFieldComp
            name='company'
            value={company || ''}
            label='Company'
            placeholder='Enter Company Name'
            onChange={handleChangeFields}
            disable={isViewOnly}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          className={clsx(classes.adjust__align, classes.padding__left)}
        >
          <TextFieldComp
            name='referalSource'
            value={referalSource || ''}
            label='Referral Source'
            placeholder='Enter Source Name'
            onChange={handleChangeFields}
            disable={isViewOnly}
          />
        </Grid>

        <Grid
          item
          xs={12}
          md={6}
          className={clsx(classes.adjust__align, classes.padding__right)}
        >
          <Typography className={clsx(classes.padding__btm__0, classes.label)}>
            Labor Class
          </Typography>
          <CustomSelect
            value={laborClassLabel}
            testId='labourClassDropdown'
            menuItems={laborClassOptions}
            customStyle={{ ...selectStyle }}
            handleChange={(option) => {
              handleChangeFields({
                target: { name: 'labourClassId', value: option?.value },
              });
              setLaborClassLabel(option?.name);
            }}
            disabled={isViewOnly}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          className={clsx(classes.adjust__align, classes.padding__left)}
        >
          <Tags
            usedIn='ro_edit_customer'
            tags={useMemo(() => tags, [])}
            isViewOnly={isViewOnly}
            tagsToUpdate={(value) => {
              handleChangeFields({
                target: {
                  name: 'tags',
                  value,
                },
              });
            }}
          />
        </Grid>

        <Grid
          item
          xs={12}
          md={6}
          className={clsx(classes.adjust__align, classes.padding__right)}
        >
          <TextFieldComp
            name='usDotNumber'
            value={usDotNumber || ''}
            label='USDOT Number'
            placeholder='Enter USDOT Number'
            onChange={(e) => {
              if (e.target.value?.length > 24) return;
              handleChangeFields(e);
            }}
            disable={isViewOnly}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          className={clsx(classes.adjust__align, classes.padding__left)}
        >
          <TextFieldComp
            name='pstNumber'
            value={pstNumber || ''}
            label='PST Number'
            placeholder='Enter PST NUmber'
            onChange={(e) => {
              if (e.target.value?.length > 24) return;
              handleChangeFields(e);
            }}
            disable={isViewOnly}
          />
        </Grid>

        <Grid item xs={12} md={12}>
          <MultipleEmailFields
            disable={isViewOnly}
            emails={additionalEmails}
            handleChangeFields={handleChangeFields}
          />
        </Grid>

        <Grid item xs={12} md={12}>
          <TextFieldComp
            name='notes'
            value={notes || ''}
            label='Customer Notes'
            placeholder='Add a Note'
            onChange={handleChangeFields}
            disable={isViewOnly}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <FormControlLabel
            checked={Boolean(isTaxExempt)}
            name='isTaxExempt'
            onChange={(e) => {
              handleChangeFields({
                target: {
                  value: e.target.checked,
                  name: 'isTaxExempt',
                },
              });
            }}
            control={
              <Checkbox
                style={{
                  color: 'green', // Set the color of the checkbox to green
                }}
              />
            }
            label='Tax Exempt.
              '
          />
        </Grid>
      </Grid>
    </>
  );
}
